export default __webpack_public_path__ + "static/media/fios-01.528d7022.jpg";